/**
 * This JS has been implemented taking heavy inspiration from https://github.com/Strategery-Inc/Magento2-InfiniteScroll
 */
define([
    "jquery",
    "jquery-ias",
    'jquery-ias/extension/history',
    'jquery-ias/extension/noneleft',
    'jquery-ias/extension/paging',
    'jquery-ias/extension/spinner',
    'jquery-ias/extension/trigger'
], function($, ias, IASHistoryExtension, IASNoneLeftExtension, IASPagingExtension, IASSpinnerExtension, IASTriggerExtension) {
    "use strict";
    var MunroIAS = {
        init: function(){
            // get system config:
            var config = {
                item: '.product-list__item',
                container : '.product-list',
                next: '.pager__item--next',
                pagination: false, // This tells the plugin to not hide the pagination links
                delay: 600,
                negativeMargin: 150,
                history: {
                    prev: '.pager__item--previous'
                },
                noneleft: { //Don't need to show anything when all results are loaded
                    text: '',
                    html: ''
                },
                spinner: {
                    src: 'data:image/gif;base64,R0lGODlhEAAQAPQAAP///wAAAPDw8IqKiuDg4EZGRnp6egAAAFhYWCQkJKysrL6+vhQUFJycnAQEBDY2NmhoaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAAFdyAgAgIJIeWoAkRCCMdBkKtIHIngyMKsErPBYbADpkSCwhDmQCBethRB6Vj4kFCkQPG4IlWDgrNRIwnO4UKBXDufzQvDMaoSDBgFb886MiQadgNABAokfCwzBA8LCg0Egl8jAggGAA1kBIA1BAYzlyILczULC2UhACH5BAkKAAAALAAAAAAQABAAAAV2ICACAmlAZTmOREEIyUEQjLKKxPHADhEvqxlgcGgkGI1DYSVAIAWMx+lwSKkICJ0QsHi9RgKBwnVTiRQQgwF4I4UFDQQEwi6/3YSGWRRmjhEETAJfIgMFCnAKM0KDV4EEEAQLiF18TAYNXDaSe3x6mjidN1s3IQAh+QQJCgAAACwAAAAAEAAQAAAFeCAgAgLZDGU5jgRECEUiCI+yioSDwDJyLKsXoHFQxBSHAoAAFBhqtMJg8DgQBgfrEsJAEAg4YhZIEiwgKtHiMBgtpg3wbUZXGO7kOb1MUKRFMysCChAoggJCIg0GC2aNe4gqQldfL4l/Ag1AXySJgn5LcoE3QXI3IQAh+QQJCgAAACwAAAAAEAAQAAAFdiAgAgLZNGU5joQhCEjxIssqEo8bC9BRjy9Ag7GILQ4QEoE0gBAEBcOpcBA0DoxSK/e8LRIHn+i1cK0IyKdg0VAoljYIg+GgnRrwVS/8IAkICyosBIQpBAMoKy9dImxPhS+GKkFrkX+TigtLlIyKXUF+NjagNiEAIfkECQoAAAAsAAAAABAAEAAABWwgIAICaRhlOY4EIgjH8R7LKhKHGwsMvb4AAy3WODBIBBKCsYA9TjuhDNDKEVSERezQEL0WrhXucRUQGuik7bFlngzqVW9LMl9XWvLdjFaJtDFqZ1cEZUB0dUgvL3dgP4WJZn4jkomWNpSTIyEAIfkECQoAAAAsAAAAABAAEAAABX4gIAICuSxlOY6CIgiD8RrEKgqGOwxwUrMlAoSwIzAGpJpgoSDAGifDY5kopBYDlEpAQBwevxfBtRIUGi8xwWkDNBCIwmC9Vq0aiQQDQuK+VgQPDXV9hCJjBwcFYU5pLwwHXQcMKSmNLQcIAExlbH8JBwttaX0ABAcNbWVbKyEAIfkECQoAAAAsAAAAABAAEAAABXkgIAICSRBlOY7CIghN8zbEKsKoIjdFzZaEgUBHKChMJtRwcWpAWoWnifm6ESAMhO8lQK0EEAV3rFopIBCEcGwDKAqPh4HUrY4ICHH1dSoTFgcHUiZjBhAJB2AHDykpKAwHAwdzf19KkASIPl9cDgcnDkdtNwiMJCshACH5BAkKAAAALAAAAAAQABAAAAV3ICACAkkQZTmOAiosiyAoxCq+KPxCNVsSMRgBsiClWrLTSWFoIQZHl6pleBh6suxKMIhlvzbAwkBWfFWrBQTxNLq2RG2yhSUkDs2b63AYDAoJXAcFRwADeAkJDX0AQCsEfAQMDAIPBz0rCgcxky0JRWE1AmwpKyEAIfkECQoAAAAsAAAAABAAEAAABXkgIAICKZzkqJ4nQZxLqZKv4NqNLKK2/Q4Ek4lFXChsg5ypJjs1II3gEDUSRInEGYAw6B6zM4JhrDAtEosVkLUtHA7RHaHAGJQEjsODcEg0FBAFVgkQJQ1pAwcDDw8KcFtSInwJAowCCA6RIwqZAgkPNgVpWndjdyohACH5BAkKAAAALAAAAAAQABAAAAV5ICACAimc5KieLEuUKvm2xAKLqDCfC2GaO9eL0LABWTiBYmA06W6kHgvCqEJiAIJiu3gcvgUsscHUERm+kaCxyxa+zRPk0SgJEgfIvbAdIAQLCAYlCj4DBw0IBQsMCjIqBAcPAooCBg9pKgsJLwUFOhCZKyQDA3YqIQAh+QQJCgAAACwAAAAAEAAQAAAFdSAgAgIpnOSonmxbqiThCrJKEHFbo8JxDDOZYFFb+A41E4H4OhkOipXwBElYITDAckFEOBgMQ3arkMkUBdxIUGZpEb7kaQBRlASPg0FQQHAbEEMGDSVEAA1QBhAED1E0NgwFAooCDWljaQIQCE5qMHcNhCkjIQAh+QQJCgAAACwAAAAAEAAQAAAFeSAgAgIpnOSoLgxxvqgKLEcCC65KEAByKK8cSpA4DAiHQ/DkKhGKh4ZCtCyZGo6F6iYYPAqFgYy02xkSaLEMV34tELyRYNEsCQyHlvWkGCzsPgMCEAY7Cg04Uk48LAsDhRA8MVQPEF0GAgqYYwSRlycNcWskCkApIyEAOwAAAAAAAAAAAA==',
                    html: '<div class="ias-trigger ias-trigger-next" style="text-align: center; cursor: pointer;"><button class="ias-load-button loading">Loading</button></div>'
                },
                trigger: {
                    text: 'Load More',
                    html: '<div class="ias-trigger ias-trigger-next" style="text-align: center; cursor: pointer;"><button class="ias-load-button">{text}</button></div>',
                    textPrev: 'Load Previous',
                    htmlPrev: '<div class="ias-trigger ias-trigger-prev" style="text-align: center; cursor: pointer;"><button class="ias-load-button">{text}</button></div>',
                    offset: 9999 //Unreasonably high number which would hopefully cover the highest possible number of pages, so load more is always automatic
                }
            };

            // check for custom configurations:
            if (window.iasConfigCustom){
                $.extend(config, window.iasConfigCustom);
            }

            var ias = $.ias(config);
            ias.extension(new IASPagingExtension());
            ias.extension(new IASSpinnerExtension(config.spinner));
            ias.extension(new IASNoneLeftExtension(config.noneleft));
            ias.extension(new IASTriggerExtension(config.trigger));
            ias.extension(new IASHistoryExtension(config.history));

            ias.on('loaded', function(data, items){
                var quickviewHtml = $(data).find("#quickview-data").html();
                if (typeof quickviewHtml !== 'undefined') {
                    var quickviewData = quickviewHtml.trim().replace('var quickViewData = ', '').slice(0, -1);
                    var $newQuickViewData = JSON.parse(quickviewData);
                    $.extend(quickViewData, $newQuickViewData);
                }
            });

            $('.toolbar').show();

            // custom fix for url protocol issue in jquery ias library:
            ias.getNextUrl = function(container) {
                if (!container) {
                    container = ias.$container;
                }
                // always take the last matching item + fix to be protocol relative
                var nexturl = $(ias.nextSelector, container).last().attr('href');
                if(typeof nexturl !== "undefined") {
                    if (window.location.protocol == 'https:') {
                        nexturl = nexturl.replace('http:', window.location.protocol);
                    } else {
                        nexturl = nexturl.replace('https:', window.location.protocol);
                    }
                }
                return nexturl;
            };

            /**
             * Custom override for the ajax allowing us to disable jQuery's built-in cachebuster.
             * This required switching from $.get to $.ajax since only the latter supports settings as a parameter
             * in the jQuery version currently live on the site.
             */
            ias.load = function(url, callback, delay) {
                var self = this,
                    $itemContainer,
                    items = [],
                    timeStart = +new Date(),
                    timeDiff;

                delay = delay || this.defaultDelay;

                var loadEvent = {
                    url: url
                };

                self.fire('load', [loadEvent]);

                this.jsXhr = $.ajax({
                    url: loadEvent.url,
                    cache: true,
                    success: $.proxy(function (data) {
                        $itemContainer = $(this.itemsContainerSelector, data).eq(0);
                        if (0 === $itemContainer.length) {
                            $itemContainer = $(data).filter(this.itemsContainerSelector).eq(0);
                        }

                        if ($itemContainer) {
                            $itemContainer.find(this.itemSelector).each(function () {
                                items.push(this);
                            });
                        }

                        // Extract the .pager__list element from the returned data, and replace the pager__list element on
                        // the page. This will mean that pagination numbers will be updated as expected
                        $('.pager__list').html($('.pager__list', data).html());

                        self.fire('loaded', [data, items]);

                        if (callback) {
                            timeDiff = +new Date() - timeStart;
                            if (timeDiff < delay) {
                                setTimeout(function () {
                                    callback.call(self, data, items);
                                }, delay - timeDiff);
                            } else {
                                callback.call(self, data, items);
                            }
                        }
                    }, self)
                });

                return this.jsXhr;
            };
            // custom infinitescroll done event:
            $(document).trigger( "infiniteScrollReady", [ias]);
            // Reinitialize after all ias modifications have been made
            ias.reinitialize();
            return ias;
        }
    };

    MunroIAS.init();
});
